import { memo } from "react";

import { CarouselItemV2 } from "./CarouselV2";
export default memo(CarouselItemV2);
